import Accordion from '../accordion/accordion';
import {
  renderContentBlocks,
  type ContentBlock,
} from '../../../lib/utils/render-content-blocks';
import type { AccordionData, FormAccordionsProps } from './types';

function renderSections(
  sections: AccordionData['sections'],
  keyPrefix: string,
) {
  return sections.map((section, i) => (
    <div key={i}>
      <p className="mb-1.5 font-medium text-prompt-safecomvulcan">
        {section.heading}
      </p>
      <div className="space-y-1">
        {renderContentBlocks(
          section.content as ContentBlock[],
          `${keyPrefix}-${i}`,
        )}
      </div>
    </div>
  ));
}

export function FormAccordions({
  tipsAccordion,
  exampleAccordion,
}: FormAccordionsProps): JSX.Element {
  return (
    <>
      <Accordion
        title={tipsAccordion.title}
        openByDefault={false}
        variant="white"
      >
        <div className="space-y-4 text-sm text-prompt-safecomabbey">
          {renderSections(tipsAccordion.sections, 'tips')}
        </div>
      </Accordion>

      <Accordion
        title={exampleAccordion.title}
        openByDefault={false}
        variant="white"
        className="!mt-3"
      >
        <div className="space-y-4 text-sm text-prompt-safecomabbey">
          {renderSections(exampleAccordion.sections, 'example')}
        </div>
      </Accordion>
    </>
  );
}
